import { useDataFormat, useDataValue } from 'Simple/Data'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let currentUserId = useDataValue({
    viewPath: props.viewPath,
    context: 'auth',
    path: 'access_token_data.user_id',
  })
  let ids = useDataFormat({
    viewPath: props.viewPath,
    context: 'manual_action_execution_ids',
    // Filter here to prevent multiplexing issues in Hasura.
    // Even though the table has a limit of 1000 rows, we rarely see 10 at the same time
    // since clinics either act on it right away by doing the action or ignoring it so
    // the filter being at the XID level shouldn't be a problem with the amount of data
    // even in large clinics.
    format: value =>
      value.filter(item => item.user_id === currentUserId).map(item => item.id),
  })

  return {
    variables: { ids },
    pause: ids.length === 0,
  }
}
